import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  root: {
    // 8 -> header, 6 -> routing tabs
    marginTop: theme.spacing(1),
    height: `calc(100vh - ${theme.spacing(8 + 6 + 1)})`,
    [theme.breakpoints.down('md')]: {
      // 36px -> footer button
      height: `calc(100vh - ${theme.spacing(8 + 6 + 4)} - 40px)`,
    },
  },
  toolBar: {
    backgroundColor: theme.palette.common.white,
  },
  searchBar: {
    flex: 1,
    marginLeft: theme.spacing(2),
  },
  articleContainer: {
    height: `calc(100vh - 64px - 48px - 8px - 64px - 76px)`,
    padding: theme.spacing(0, 2.85, 0, 0),
    position: 'relative',
  },
  list: {
    padding: `0 ${theme.spacing(2)}`,
  },
  tabsAppBar: {
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    boxShadow: 'none',
    margin: theme.spacing(3.5, 2.85, 0, 2),
    width: 'auto',
  },
}));
